import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Typography,
  useTheme,
  useMediaQuery,
  Box,
} from '@mui/material';
import { Sparkles } from 'lucide-mui';

interface CustomPromptDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (customTemplate: string) => void;
}

const CustomPromptDialog: React.FC<CustomPromptDialogProps> = ({
  open,
  onClose,
  onSubmit,
}) => {
  const [customTemplate, setCustomTemplate] = useState('');
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleSubmit = () => {
    if (customTemplate.trim()) {
      onSubmit(customTemplate.trim());
      setCustomTemplate('');
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: {
          m: isMobile ? 2 : 3,
          width: isMobile ? 'calc(100% - 32px)' : undefined,
          maxHeight: isMobile ? 'calc(100% - 32px)' : undefined,
        },
      }}
    >
      <Box
        sx={{
          p: 2,
          borderBottom: 1,
          borderColor: 'divider',
        }}
      >
        <Typography variant="subtitle1">Custom Template</Typography>
      </Box>
      <DialogContent>
        <Typography variant="body2" color="textSecondary" gutterBottom>
          Enter a custom template below. Start with a clear instruction,
          followed by specific details you want to include.
        </Typography>
        <Typography variant="body2" color="textSecondary" gutterBottom>
          Example: &quot;Summarize the main points of the meeting. Include: 1.
          Key decisions made 2. Action items with owners 3. Next meeting
          date&quot;
        </Typography>
        <TextField
          autoFocus
          margin="dense"
          label="Custom Template"
          type="text"
          fullWidth
          multiline
          rows={4}
          value={customTemplate}
          onChange={(e) => setCustomTemplate(e.target.value)}
        />
      </DialogContent>
      <DialogActions sx={{ p: 2, pt: 0 }}>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={handleSubmit}
          color="primary"
          variant="contained"
          disableElevation
          startIcon={<Sparkles />}
        >
          Generate
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CustomPromptDialog;
